import { loadState, saveState } from "./storage";

function uid() {
  return Math.random().toString(36).slice(2) + Date.now().toString(36);
}

export function getChildren() {
  return loadState().children || [];
}

export function getActiveChild() {
  const s = loadState();
  const kids = s.children || [];
  return kids.find((c) => c.id === s.activeChildId) || null;
}

export function setActiveChild(childId) {
  const s = loadState();
  s.activeChildId = childId;
  return saveState(s);
}

export function addChild(child) {
  const s = loadState();
  const id = uid();
  const kids = s.children || [];
  const nextChild = {
    id,
    name: child.name || "Child",
    avatar: child.avatar || "SMILE",
    age: child.age || "",
    allergens: child.allergens || [],
    emergencyInstructions:
      child.emergencyInstructions ||
      child?.profile?.medicalInfo?.emergencyInstructions ||
      "",
    profile: {
      medicalInfo: {
        hasAsthma: !!child?.profile?.medicalInfo?.hasAsthma,
        medications: child?.profile?.medicalInfo?.medications || "",
        reactionType: child?.profile?.medicalInfo?.reactionType || "standard",
        emergencyInstructions:
          child?.profile?.medicalInfo?.emergencyInstructions ||
          child.emergencyInstructions ||
          "",
      },
      safetySettings: {
        crossContactSensitivity: !!child?.profile?.safetySettings?.crossContactSensitivity,
        prefersDedicatedFacility: !!child?.profile?.safetySettings?.prefersDedicatedFacility,
      },
    },
    hasEpiPen: !!child.hasEpiPen,
    epiPenLocation: child.epiPenLocation || "",
    emergencyContacts: child.emergencyContacts || [],
    parentNotes: child.parentNotes || "",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  };
  s.children = [nextChild, ...kids];
  if (!s.activeChildId) s.activeChildId = id;
  return saveState(s);
}

export function updateChild(childId, patch) {
  const s = loadState();
  s.children = (s.children || []).map((c) => {
    if (c.id !== childId) return c;
    return {
      ...c,
      ...patch,
      profile: {
        medicalInfo: {
          hasAsthma:
            patch?.profile?.medicalInfo?.hasAsthma ??
            c.profile?.medicalInfo?.hasAsthma ??
            false,
          medications:
            patch?.profile?.medicalInfo?.medications ??
            c.profile?.medicalInfo?.medications ??
            "",
          reactionType:
            patch?.profile?.medicalInfo?.reactionType ||
            c.profile?.medicalInfo?.reactionType ||
            "standard",
          emergencyInstructions:
            patch?.profile?.medicalInfo?.emergencyInstructions ??
            c.profile?.medicalInfo?.emergencyInstructions ??
            c.emergencyInstructions ??
            "",
        },
        safetySettings: {
          crossContactSensitivity:
            patch?.profile?.safetySettings?.crossContactSensitivity ??
            c.profile?.safetySettings?.crossContactSensitivity ??
            false,
          prefersDedicatedFacility:
            patch?.profile?.safetySettings?.prefersDedicatedFacility ??
            c.profile?.safetySettings?.prefersDedicatedFacility ??
            false,
        },
      },
      updatedAt: new Date().toISOString(),
    };
  });
  return saveState(s);
}

export function deleteChild(childId) {
  const s = loadState();
  s.children = (s.children || []).filter((c) => c.id !== childId);
  if (s.activeChildId === childId) {
    s.activeChildId = s.children[0]?.id || null;
  }
  return saveState(s);
}
